module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town")]), _vm._v(" "), _c('p', {
    staticClass: "ctc",
    attrs: {
      "id": "pArz"
    }
  }, [_c('i', [_vm._v("Contents")]), _c('a', {
    attrs: {
      "id": "pAR"
    }
  })]), _c('a', {
    attrs: {
      "id": "pAR"
    }
  }), _c('p', {
    staticClass: "cct1"
  }, [_c('a', {
    attrs: {
      "id": "pAR"
    }
  }), _c('a', {
    attrs: {
      "href": "#/chapter03#CC_03",
      "id": "RR_03"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter04#CC_04",
      "id": "RR_04"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter05#CC_05",
      "id": "RR_05"
    }
  }, [_vm._v("THE ANDY GRIFFITH SHOW")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter08#CC_08",
      "id": "RR_08"
    }
  }, [_vm._v("BEVERAGES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter09#CC_09",
      "id": "RR_09"
    }
  }, [_vm._v("REGAL ORDER ROOT BEER ICE CREAM FLUFF")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter10#CC_10",
      "id": "RR_10"
    }
  }, [_vm._v("FLOYD’S PUNCH IN THE MOUTH")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter11#CC_11",
      "id": "RR_11"
    }
  }, [_vm._v("WALLY’S BOTTLE OF POP FLOAT")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter12#CC_12",
      "id": "RR_12"
    }
  }, [_vm._v("ELINOR’S EGGNOG")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter13#CC_13",
      "id": "RR_13"
    }
  }, [_vm._v("MAYBERRY HOSPITALITY LEMONADE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter14#CC_14",
      "id": "RR_14"
    }
  }, [_vm._v("TWEEKY’S CLASS REUNION PUNCH")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter15#CC_15",
      "id": "RR_15"
    }
  }, [_vm._v("RUSSIAN DIPLOMAT TEA")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter16#CC_16",
      "id": "RR_16"
    }
  }, [_vm._v("HOT PLATE HOT CHOCOLATE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter17#CC_17",
      "id": "RR_17"
    }
  }, [_vm._v("LADY SHOPLIFTER’S CHOCOLATE NONFAT MILKSHAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter18#CC_18",
      "id": "RR_18"
    }
  }, [_vm._v("MYERS LAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter19#CC_19",
      "id": "RR_19"
    }
  }, [_vm._v("HOWARD’S BACHELOR PAD PUNCH")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter21#CC_21",
      "id": "RR_21"
    }
  }, [_vm._v("BREADS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter22#CC_22",
      "id": "RR_22"
    }
  }, [_vm._v("MRS. LESCH’S LEMON BREAD")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter23#CC_23",
      "id": "RR_23"
    }
  }, [_vm._v("MAYBERRY MOLASSES BREAD")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24#CC_24",
      "id": "RR_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JIMMY’S CHEW BREAD")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25#CC_25",
      "id": "RR_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GOOBER BEANIE ZUCCHINI BREAD")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26#CC_26",
      "id": "RR_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BARNEY’S JUDO GINGERBREAD")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27#CC_27",
      "id": "RR_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEPRESSION PANCAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28#CC_28",
      "id": "RR_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MR. GOSS’S GOLDEN PUFFS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#CC_29",
      "id": "RR_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CRANSTON’S CRANBERRY APPLE LOAF")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30#CC_30",
      "id": "RR_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COUNTRY GIRL’S BANANA-CARROT-GINGER BREAD")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31#CC_31",
      "id": "RR_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAIN STREET MONKEY BREAD")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter32#CC_32",
      "id": "RR_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("UNTAPPED SOURCE OF LIFETIME HAPPINESS BLUEBERRY MUFFINS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter33#CC_33",
      "id": "RR_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BANANA NUTSY BREAD")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter34#CC_34",
      "id": "RR_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ROMEENA’S CREAMED CORN STICKS SURPRISE!")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter35#CC_35",
      "id": "RR_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAMA MORELLI’S MODERN PANETTONE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter36#CC_36",
      "id": "RR_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SHOPLIFTER’S STICKY BUNS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter37#CC_37",
      "id": "RR_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STRANGER IN TOWN STRAWBERRY BREAD")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter38#CC_38",
      "id": "RR_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WALLY’S SUPER PUMPKIN-NUT BREAD")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter39#CC_39",
      "id": "RR_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("KEEPER OF THE DOOR MONKEY BREAD")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter41#CC_41",
      "id": "RR_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CAKES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter42#CC_42",
      "id": "RR_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUNT EDNA’S CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter43#CC_43",
      "id": "RR_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HELEN’S HOMEMADE FIVE-POUND FRUIT CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter44#CC_44",
      "id": "RR_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHARLIE VARNEY’S VANILLA WAFER CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter45#CC_45",
      "id": "RR_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUMMER’S DAY DESSERT")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter46#CC_46",
      "id": "RR_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HEARTY EATIN’ HEAVENLY HASH CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter47#CC_47",
      "id": "RR_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STRAWBERRY FESTIVAL CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter48#CC_48",
      "id": "RR_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MILLIE’S CHOCOLATE CHIP CHOCOLATE CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter49#CC_49",
      "id": "RR_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BOYSINGER’S BAKERY COCOA CUPCAKES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter50#CC_50",
      "id": "RR_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEPUTY FIFE’S DUSTY GUN STREUSEL COFFEE CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter51#CC_51",
      "id": "RR_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ROGER HANOVER’S CHEESECAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter52#CC_52",
      "id": "RR_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BOTTLE OF POP CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter53#CC_53",
      "id": "RR_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LOADED GOAT BLUEBERRY CHEESECAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter54#CC_54",
      "id": "RR_54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MRS. HAWKIN’S CHOCOLATE CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter55#CC_55",
      "id": "RR_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MRS. WILEY’S WINE CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter56#CC_56",
      "id": "RR_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IRMA BISHOP’S MISS CONGENIALITY CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter57#CC_57",
      "id": "RR_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NAME AIN’T CLEM APPLESAUCE CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter58#CC_58",
      "id": "RR_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WALLY’S 7-UP POUND CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter59#CC_59",
      "id": "RR_59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BEAST OF THE FOURTH FLOOR BANANA SPLIT CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter60#CC_60",
      "id": "RR_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ERNEST T.’S MOTHER FIGURE FIG PRESERVES LOAF CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter61#CC_61",
      "id": "RR_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BIG ORANGE SLICE FRUIT CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter62#CC_62",
      "id": "RR_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HUBCAPS LESCH’S LUCKY LEMON SOUR CREAM POUND CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter63#CC_63",
      "id": "RR_63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MT. PILOT PIG PICKIN’ CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter64#CC_64",
      "id": "RR_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SILER CITY CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter65#CC_65",
      "id": "RR_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MR. MCBEEVEE’S APPLE TORTE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter66#CC_66",
      "id": "RR_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OPIE’S APPLE CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter67#CC_67",
      "id": "RR_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CAVE RESCUE COFFEE CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter68#CC_68",
      "id": "RR_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LAZY DAYS OATMEAL CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter69#CC_69",
      "id": "RR_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EVIE-JOY’S BABY FOOD CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter70#CC_70",
      "id": "RR_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COUNTY FAIR CRANBERRY CAKE WITH HOT BUTTER SAUCE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter71#CC_71",
      "id": "RR_71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MOTHER’S BLACK WALNUT CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter72#CC_72",
      "id": "RR_72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SALLY’S RED VELVET CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter73#CC_73",
      "id": "RR_73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HAPPY MOTORING CHEESECAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter74#CC_74",
      "id": "RR_74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANDY’S NUT CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter75#CC_75",
      "id": "RR_75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAYBERRY ON RECORD CHERRY UPSIDE-DOWN CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter76#CC_76",
      "id": "RR_76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GRANDMA’S ORANGE CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter77#CC_77",
      "id": "RR_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JELLY JAIL CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter78#CC_78",
      "id": "RR_78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BEAUTIFUL, DELICATE WOMEN’S PECAN CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter79#CC_79",
      "id": "RR_79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HAZEL’S POUND CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter80#CC_80",
      "id": "RR_80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ALMA’S BUTTERMILK POUND CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter81#CC_81",
      "id": "RR_81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SALLY’S FAVORITE FRUIT BUNDT CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter82#CC_82",
      "id": "RR_82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FLOYD’S CABIN FEVER BANANA CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter83#CC_83",
      "id": "RR_83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STRAWBERRY FIELDS SHORT CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter84#CC_84",
      "id": "RR_84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BARNEY’S FIRST CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter85#CC_85",
      "id": "RR_85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HARRIET’S RICH STRAWBERRY CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter86#CC_86",
      "id": "RR_86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STRONGBOW’S STRAWBERRY PECAN CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter87#CC_87",
      "id": "RR_87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LEON’S PEANUT BUTTER FUDGE CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter88#CC_88",
      "id": "RR_88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHARLENE’S SAD CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter89#CC_89",
      "id": "RR_89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("POUNDED CAKE À LA MORELLI")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter90#CC_90",
      "id": "RR_90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LINKE FAMILY LUCHEN KUGEL")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter91#CC_91",
      "id": "RR_91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANGEL CAKE ANGE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter92#CC_92",
      "id": "RR_92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SHERIFF’S CHOCOLATE COOKIE SHEET CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter93#CC_93",
      "id": "RR_93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TWO PLUS TWO STRAWBERRY CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter94#CC_94",
      "id": "RR_94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OLD FAMILY RECIPE EGGLESS FRUITCAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter95#CC_95",
      "id": "RR_95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NANA’S POUND CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter96#CC_96",
      "id": "RR_96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GOMER’S FILL ’ER UP CHOCOLATE CUPCAKES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter97#CC_97",
      "id": "RR_97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MALCOLM’S CUPCAKES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter98#CC_98",
      "id": "RR_98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HUGO HOPFLEISCH’S BAVARIAN CREAM CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter99#CC_99",
      "id": "RR_99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DUCK POND DOUBLE DATE CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter100#CC_100",
      "id": "RR_100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OLD MAN KELSEY’S CREEK MUD CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter101#CC_101",
      "id": "RR_101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WILBUR SAUNDERS’ BANANA CUPCAKES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter102#CC_102",
      "id": "RR_102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MOMMIE’S PINEAPPLE UPSIDE-DOWN CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter103#CC_103",
      "id": "RR_103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHECKPOINT CHICKEY CHOCOLATE UPSIDE-DOWN CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter104#CC_104",
      "id": "RR_104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OPIE’S LEMONADE CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter105#CC_105",
      "id": "RR_105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CALL THE MAN KELVINATOR FRUIT CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter106#CC_106",
      "id": "RR_106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GOOBER CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter107#CC_107",
      "id": "RR_107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WILL YOU LOVE ME WHEN I’M OLD AND UGLY PERSIMMON CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter108#CC_108",
      "id": "RR_108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EMBLEM OIL’S AMAZING CHOCOLATE CHIP POUND CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter109#CC_109",
      "id": "RR_109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRESH APPLE BLOSSOM FESTIVAL CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter110#CC_110",
      "id": "RR_110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SISTER ANN ELIZABETH’S BOURBON POUND CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter111#CC_111",
      "id": "RR_111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DUD’S CRACKER CRUMMY CHEESECAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter112#CC_112",
      "id": "RR_112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DISHTOWEL SALESMAN SPONGE CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter113#CC_113",
      "id": "RR_113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAMA’S CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter114#CC_114",
      "id": "RR_114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COUSIN LILLIAN’S PINEAPPLE CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter115#CC_115",
      "id": "RR_115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JIM LINDSEY’S BEST HOLIDAY CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter116#CC_116",
      "id": "RR_116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OPIE’S OVERACHIEVING ORANGE GLAZE CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter117#CC_117",
      "id": "RR_117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MR. RUSKIN’S VIENNA TORTE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter118#CC_118",
      "id": "RR_118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MRS. WILEY’S PUNCH BOWL CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter119#CC_119",
      "id": "RR_119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CITIZEN’S ARREST CHOCOLATE CHEESECAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter120#CC_120",
      "id": "RR_120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUNT BEE’S TOOT-TOOT-TOOTSIE HELLO CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter121#CC_121",
      "id": "RR_121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RAFE HOLLISTER’S KAHLUA CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter122#CC_122",
      "id": "RR_122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BLEW THE SCRAMEZ-VOUS CHERRY PINEAPPLE NUT CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter123#CC_123",
      "id": "RR_123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TROUBLESOME HOLLER CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter124#CC_124",
      "id": "RR_124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RODNEY’S GOOEY BUTTER CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter125#CC_125",
      "id": "RR_125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CLUBMEN’S BAKED ALASKA")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter126#CC_126",
      "id": "RR_126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DARLING BOYS MOUNTAIN DEW CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter127#CC_127",
      "id": "RR_127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HOGETTE WINSLOW’S CAKETTE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter128#CC_128",
      "id": "RR_128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CLARA’S NEPHEW FERDIE’S ACCORDION ITALIAN RUM CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter129#CC_129",
      "id": "RR_129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BEE TAYLOR’S DEEP PINK ECSTASY")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter130#CC_130",
      "id": "RR_130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GOOD APPLE KUCHEN")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter131#CC_131",
      "id": "RR_131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HOWARD SPRAGUE’S ISLAND COCONUT CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter132#CC_132",
      "id": "RR_132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CREAMY CAROLINA COFFEE CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter133#CC_133",
      "id": "RR_133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SHERIFF’S PAY DAY CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter134#CC_134",
      "id": "RR_134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BARNEY’S CHOCOLATE MOULAGE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter136#CC_136",
      "id": "RR_136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CANDIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter137#CC_137",
      "id": "RR_137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TAYLOR-MADE CANDY STRAWBERRIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter138#CC_138",
      "id": "RR_138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RALEIGH ALMOND BUTTER CRUNCH")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter139#CC_139",
      "id": "RR_139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TREY BOWDEN’S COCONUT BON-BONS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter140#CC_140",
      "id": "RR_140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GOOD OL’ 14-A NUT ROLLS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter141#CC_141",
      "id": "RR_141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COLONEL HARVEY’S CREAMY MOCHA FUDGE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter142#CC_142",
      "id": "RR_142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BRISCOE’S BRITTLE BRACK BRITTLE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter143#CC_143",
      "id": "RR_143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CALL THE ROLL PECAN ROLL")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter144#CC_144",
      "id": "RR_144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WEAVER’S PEANUT BUTTER FUDGE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter145#CC_145",
      "id": "RR_145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WEDNESDAY NIGHT CHOCOLATE FUDGE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter146#CC_146",
      "id": "RR_146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DR. PENDYKE’S PEANUT BRITTLE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter147#CC_147",
      "id": "RR_147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PISTOL-PACKIN’ PECAN PRALINES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter148#CC_148",
      "id": "RR_148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BATTLE OF MAYBERRY BRIDGE BUTTERSCOTCH FUDGE LOG")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter149#CC_149",
      "id": "RR_149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LORRAINE’S FUDGE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter150#CC_150",
      "id": "RR_150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BRISCOE’S BUCKEYES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter151#CC_151",
      "id": "RR_151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OLD MAN MACKNIGHT’S POPCORN BALLS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter152#CC_152",
      "id": "RR_152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FULL MOON BUTTERSCOTCH PECAN CANDY")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter153#CC_153",
      "id": "RR_153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IRENE PHLOGG’S PEANUT BUTTER FUDGE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter154#CC_154",
      "id": "RR_154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CLAUDE’S CRUNCHY CHOCOLATE FUDGE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter155#CC_155",
      "id": "RR_155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHRISTMAS STRAWBERRY DIVINITY")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter156#CC_156",
      "id": "RR_156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MORRISON SISTERS’ BOURBON BALLS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter157#CC_157",
      "id": "RR_157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MARTHA WASHINGTON CANDY")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter158#CC_158",
      "id": "RR_158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MRS. WILEY’S CARAMEL APPLE SLICES ANKRUM")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter159#CC_159",
      "id": "RR_159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("POST TOASTIES CANDY")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter160#CC_160",
      "id": "RR_160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ERNEST T. BASS ROCK CANDY")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter161#CC_161",
      "id": "RR_161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MR. POTATO CANDY")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter162#CC_162",
      "id": "RR_162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CALVIN COOLIDGE CASHEW FUDGE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter164#CC_164",
      "id": "RR_164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter165#CC_165",
      "id": "RR_165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OPIE’S TRICK OR TREAT COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter166#CC_166",
      "id": "RR_166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DOBRO DUNKING PLATTERS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter167#CC_167",
      "id": "RR_167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HALF MOON TRAILER PARK PECAN CRESCENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter168#CC_168",
      "id": "RR_168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FLORRIE’S FANCY NUT COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter169#CC_169",
      "id": "RR_169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAYBERRY HOLIDAY SUGAR COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter170#CC_170",
      "id": "RR_170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HIGHWAY 6 SPEEDY GRAHAM CRACKER GOODIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter171#CC_171",
      "id": "RR_171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAGICAL MR. DAVE BROWNIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter172#CC_172",
      "id": "RR_172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GOMER’S GUN-DROP GUM DROP COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter173#CC_173",
      "id": "RR_173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHERRY BERRY BIN BARS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter174#CC_174",
      "id": "RR_174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OLD MAN REMSHAW’S HAUNTED HOUSE PUMPKIN BARS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter175#CC_175",
      "id": "RR_175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SOUND COMMITTEE POTATO CHIP COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter176#CC_176",
      "id": "RR_176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE MONSTER THAT ATE MINNESOTA SNOWBALL COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter177#CC_177",
      "id": "RR_177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OPIE’S BETTER BATTER PEANUT BUTTER COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter178#CC_178",
      "id": "RR_178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FLOSS’S WELSH CAKES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter179#CC_179",
      "id": "RR_179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TIGER FIFE’S LOW-FAT BROWNIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter180#CC_180",
      "id": "RR_180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GEORGE BARSTOW’S EASY BUTTER COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter181#CC_181",
      "id": "RR_181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MALCOLM’S CHEERIO CHERRY SQUARES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter182#CC_182",
      "id": "RR_182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HOWARD SPRAGUE’S CLASSY CUT-OUTS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter183#CC_183",
      "id": "RR_183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CAROLINA MOON CHOCOLATES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter184#CC_184",
      "id": "RR_184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUDY, JUDY, JUDY COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter185#CC_185",
      "id": "RR_185",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CROSSWAITH CHOCOLATE CHESS SQUARES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter186#CC_186",
      "id": "RR_186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ED CRUMPACKER’S SNOWBALL COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter187#CC_187",
      "id": "RR_187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAYOR PIKE’S PERSIMMON COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter188#CC_188",
      "id": "RR_188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ERNEST TEASERS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter189#CC_189",
      "id": "RR_189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GENUINE CERAMIC PELICAN PECAN SQUARES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter190#CC_190",
      "id": "RR_190",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SMALL TOWN SHORTBREAD")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter191#CC_191",
      "id": "RR_191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GUARD THE CANNON PUMPKIN COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter192#CC_192",
      "id": "RR_192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DUD’S MILK DUD COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter193#CC_193",
      "id": "RR_193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GYPSY MELODY GINGER SNAPS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter194#CC_194",
      "id": "RR_194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GOOBER’S GOBS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter195#CC_195",
      "id": "RR_195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HOPSCOTCH BUTTERSCOTCH COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter196#CC_196",
      "id": "RR_196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INSPECTOR SOMERSET’S PRUNE COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter197#CC_197",
      "id": "RR_197",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FORD GALAXIE CREAM CHEESE SQUARES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter198#CC_198",
      "id": "RR_198",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SOURWOOD MOUNTAIN SOUR CREAM APPLE SQUARES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter199#CC_199",
      "id": "RR_199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHO’S A COUNTRY BUMPKIN PUMPKIN PIE DESSERT")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter200#CC_200",
      "id": "RR_200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUNT BEE’S CANTON PALACE MORSELS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter201#CC_201",
      "id": "RR_201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHOCOLATE SQUARE DANCES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter202#CC_202",
      "id": "RR_202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DAPHNE’S THREE-LAYER CHOCOLATE SQUARES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter203#CC_203",
      "id": "RR_203",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CRIME-FREE CARAMEL SAFE CRACKERS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter204#CC_204",
      "id": "RR_204",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NIP IT IN THE BUD NO-BAKE PEANUT BUTTER BALLS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter205#CC_205",
      "id": "RR_205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAYBERRY JAIL CELLS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter206#CC_206",
      "id": "RR_206",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ROBERT GOLDEN’S CHOCOLATE CHIP COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter207#CC_207",
      "id": "RR_207",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OTIS CAMPBELL OATMEAL CHOCOLATE CHIP COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter208#CC_208",
      "id": "RR_208",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GOOBER BLOSSOMS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter209#CC_209",
      "id": "RR_209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("REGIS’S GOLD SHIPMENT BARS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter210#CC_210",
      "id": "RR_210",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EBUM, SHOOBUM, SHOOBUM, SHOOBUM PEANUT BUTTER BARS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter211#CC_211",
      "id": "RR_211",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SAM BROWNE BELT BROWNIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter212#CC_212",
      "id": "RR_212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BEASTO MARISTO LOW-FAT, HIGH-FIBER BROWNIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter213#CC_213",
      "id": "RR_213",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COUNT ISTVAN TELEKY BROWNIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter214#CC_214",
      "id": "RR_214",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("REVEREND TUCKER’S TOFFEE BARS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter215#CC_215",
      "id": "RR_215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAYBERRY DEPUTY ALMOND COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter216#CC_216",
      "id": "RR_216",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MRS. MENDELBRIGHT’S BULB-SNATCHERS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter217#CC_217",
      "id": "RR_217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EMMETT’S HARVEST BALL PUMPKIN BARS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter218#CC_218",
      "id": "RR_218",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EDGAR COLEMAN’S GLUEY, CHEWY OATMEAL COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter219#CC_219",
      "id": "RR_219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHARLOTTE’S CONCRETE JUNGLE BLOCKS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter220#CC_220",
      "id": "RR_220",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WEARY WILLIE’S BROWN SUGAR COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter221#CC_221",
      "id": "RR_221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY NIGHT DATE CHEWS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter222#CC_222",
      "id": "RR_222",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JELENE NAOMI CONNERS SCOTCH SHORTBREAD")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter223#CC_223",
      "id": "RR_223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WALKER’S DRUGSTORE CANDY BAR COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter224#CC_224",
      "id": "RR_224",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BARNEY’S THINS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter225#CC_225",
      "id": "RR_225",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAYBERRY CHERRY COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter226#CC_226",
      "id": "RR_226",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CLARENCE EARP’S COWBOY COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter227#CC_227",
      "id": "RR_227",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OLD COUNTRY LEMON SQUARES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter228#CC_228",
      "id": "RR_228",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COURTHOUSE CHRISTMAS TREE COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter229#CC_229",
      "id": "RR_229",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FLOSS’S AUSTRALIAN MUNCHIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter230#CC_230",
      "id": "RR_230",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BRISCOE’S HILL COUNTRY COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter231#CC_231",
      "id": "RR_231",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANDY’S APRICOT QUEEN SQUARES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter232#CC_232",
      "id": "RR_232",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BARNEY’S BLOODHOUND CHOCOLATE CHIP COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter235#CC_235",
      "id": "RR_235",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FROSTINGS, TOPPINGS, AND PRESERVES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter236#CC_236",
      "id": "RR_236",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUNT BEE’S HOMEMADE WATERMELON RIND PICKLES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter237#CC_237",
      "id": "RR_237",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FLOYD’S MOCHA FROSTING")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter238#CC_238",
      "id": "RR_238",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BANK JOB BAKED-ON FROSTING")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter239#CC_239",
      "id": "RR_239",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHITE HORSE ICING FOR ANGEL FOOD CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter240#CC_240",
      "id": "RR_240",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOOGATUCK’S HONEY NOUGATINE FROSTING")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter241#CC_241",
      "id": "RR_241",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ELEANORA’S PRALINE ICE CREAM SAUCE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter242#CC_242",
      "id": "RR_242",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LYDIA’S VANILLA SAUCE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter243#CC_243",
      "id": "RR_243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRUIT DIP WARREN FERGUSON")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter244#CC_244",
      "id": "RR_244",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PETER PIPER PEPPER JELLY")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter245#CC_245",
      "id": "RR_245",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COUSIN EUDORA’S STRAWBERRY PRESERVES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter246#CC_246",
      "id": "RR_246",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LAST STRAWBERRY PRESERVES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter247#CC_247",
      "id": "RR_247",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RODNEY DARLING’S PERSIMMON PUCKER UP")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter248#CC_248",
      "id": "RR_248",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LEON’S BLACKBERRY JELLY")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter250#CC_250",
      "id": "RR_250",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PIES, COBBLERS, AND PASTRIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter251#CC_251",
      "id": "RR_251",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GOMER’S HANA KEY LIME PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter252#CC_252",
      "id": "RR_252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHECKERBOARD CHESS PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter253#CC_253",
      "id": "RR_253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PEEKABOO PECAN PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter254#CC_254",
      "id": "RR_254",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MISS CRUMP’S PEANUT BUTTER PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter255#CC_255",
      "id": "RR_255",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DRUM AND FIFE CORPS CHERRY CRUNCH")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter256#CC_256",
      "id": "RR_256",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CLARA’S CHERRY COBBLER")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter257#CC_257",
      "id": "RR_257",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ERNEST T.’S E-Z COCONUT PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter258#CC_258",
      "id": "RR_258",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WILBUR FINCH’S PEACH COBBLER")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter259#CC_259",
      "id": "RR_259",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WELCOME TO MAYBERRY PINEAPPLE DESSERT")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter260#CC_260",
      "id": "RR_260",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHARLOTTE CHOCOLATE PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter261#CC_261",
      "id": "RR_261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BACHELOR BARNEY’S BLACKBERRY COBBLER")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter262#CC_262",
      "id": "RR_262",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BARNEY’S DELUXE SPECIAL FUDGE PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter263#CC_263",
      "id": "RR_263",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAN IN A HURRY COBBLER TOPPING")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter264#CC_264",
      "id": "RR_264",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BUTTER AND EGG MAN BUTTERMILK PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter265#CC_265",
      "id": "RR_265",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LAWMAN BARNEY’S FRUIT PIZZA")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter266#CC_266",
      "id": "RR_266",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CLYDE PLAUNT’S COCONUT CARAMEL PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter267#CC_267",
      "id": "RR_267",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RAFE HOLLISTER’S SWEET TATER PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter268#CC_268",
      "id": "RR_268",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OATMEAL PIE OTIS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter269#CC_269",
      "id": "RR_269",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHARLIE FOLEY’S FROZEN LEMON PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter270#CC_270",
      "id": "RR_270",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MANHUNT CHOCOLATE ALMOND PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter271#CC_271",
      "id": "RR_271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HENRY “SHOPPING BAG” LEONETTI’S APPLE PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter272#CC_272",
      "id": "RR_272",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SWEET JUANITA’S SWEET POTATO/BANANA PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter273#CC_273",
      "id": "RR_273",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BRISCOE’S DECLARIN’ MOCHA ECLAIRS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter274#CC_274",
      "id": "RR_274",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SKIPPY’S CHERRY TORTE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter275#CC_275",
      "id": "RR_275",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ARNOLD’S EASY APPLE DUMPLINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter276#CC_276",
      "id": "RR_276",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SLIMY RIVER BOTTOM PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter277#CC_277",
      "id": "RR_277",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COCK-A-DOODLE-DOO NESTS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter278#CC_278",
      "id": "RR_278",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BLUEGRASS BLUEBERRY COBBLER")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter279#CC_279",
      "id": "RR_279",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SAM’S CHOCOLATE PINEAPPLE PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter280#CC_280",
      "id": "RR_280",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COUNTY CLERK CHOCOLATE COCONUT PECAN PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter281#CC_281",
      "id": "RR_281",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MALCOLM’S JAM ROLY POLY")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter282#CC_282",
      "id": "RR_282",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MALCOLM’S SHORT-CUT SHORT CRUST PASTRY")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter283#CC_283",
      "id": "RR_283",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EARLIE GILLEY’S PECAN PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter284#CC_284",
      "id": "RR_284",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PILOT PINES PINEAPPLE CHESS PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter285#CC_285",
      "id": "RR_285",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BLUE-VUE BLUEBERRY DELIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter286#CC_286",
      "id": "RR_286",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BACKWOODS BLACKBERRY DUMPLINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter287#CC_287",
      "id": "RR_287",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CRABMAN COMIC CRANBERRY APPLE PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter288#CC_288",
      "id": "RR_288",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MARTIN PHILLIPS’ FRENCH STRAWBERRY PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter289#CC_289",
      "id": "RR_289",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RUBE SLOAN’S RHUBARB CRUMBLE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter290#CC_290",
      "id": "RR_290",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOVE YOUR RAISIN-PECAN PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter291#CC_291",
      "id": "RR_291",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ALL GOD’S CHILDREN GOT A CHOCOLATE PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter292#CC_292",
      "id": "RR_292",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANNIVERSARY WALTZ APPLE CRISP")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter293#CC_293",
      "id": "RR_293",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ELLIE’S APPLE CRISP")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter294#CC_294",
      "id": "RR_294",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHOCOLATE MIKADO")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter295#CC_295",
      "id": "RR_295",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEARLESS FIFE FRUIT COCKTAIL DESSERT")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter296#CC_296",
      "id": "RR_296",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAYBERRY SAYS THANKS PUMPKIN PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter297#CC_297",
      "id": "RR_297",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THOMAS A. MOODY’S EASY KEY LIME PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter298#CC_298",
      "id": "RR_298",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAYBERRY UNION HIGH APPLE PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter299#CC_299",
      "id": "RR_299",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAYBERRY MINUTEMEN CONCORD GRAPE PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter300#CC_300",
      "id": "RR_300",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LAURA HOLLANDER’S CAMP WINOKEE PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter301#CC_301",
      "id": "RR_301",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPLE PIZZA À LA MORELLI")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter302#CC_302",
      "id": "RR_302",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUNT BEE’S SUMMER DESSERT")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter303#CC_303",
      "id": "RR_303",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AND NOW A WORD FROM OUR SPONSOR PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter304#CC_304",
      "id": "RR_304",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("YOUR HARVARDS AND YOUR YALES CHOCOLATE PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter305#CC_305",
      "id": "RR_305",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANDY’S APPLE PIE ORDER")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter306#CC_306",
      "id": "RR_306",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A REGULAR SIN CITY CINNAMON APPLE PUFFS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter307#CC_307",
      "id": "RR_307",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHARLENE’S RHUBARB FLUFFS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter308#CC_308",
      "id": "RR_308",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FLOSS’S AUSTRALIAN PAVLOVA")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter309#CC_309",
      "id": "RR_309",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ELLIE’S PRETTY AS A PEACH COBBLER")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter310#CC_310",
      "id": "RR_310",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SOUTHERN PECAN PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter311#CC_311",
      "id": "RR_311",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHASE THE CROOKS LEMON CHESS PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter312#CC_312",
      "id": "RR_312",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("KAREN’S PERFECT LEMON PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter313#CC_313",
      "id": "RR_313",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUNT FLORENCE’S RUM PARFAIT PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter314#CC_314",
      "id": "RR_314",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEWIN’ LOVE APRICOT DESSERT")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter315#CC_315",
      "id": "RR_315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LEONARD BLUSH’S LEMON CHEESE PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter316#CC_316",
      "id": "RR_316",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HAPPY VALLEY CHOCOLATE PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter317#CC_317",
      "id": "RR_317",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CLAUDETTE BEAMON’S CHOCOLATE PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter318#CC_318",
      "id": "RR_318",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CLARA’S VINEGAR PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter319#CC_319",
      "id": "RR_319",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SCENE OF THE CRÈME DE MENTHE PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter320#CC_320",
      "id": "RR_320",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ALL SOULS CHURCH CHERRY BURST PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter321#CC_321",
      "id": "RR_321",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BLUE RIBBON CHOCOLATE-ALMOND TORTE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter322#CC_322",
      "id": "RR_322",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BLUE RIBBON GANACHE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter323#CC_323",
      "id": "RR_323",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CLASS OF ’45 FAST LEMON PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter324#CC_324",
      "id": "RR_324",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TOM’S MOTHER’S CHOCOLATE PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter325#CC_325",
      "id": "RR_325",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("O-PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter326#CC_326",
      "id": "RR_326",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GOOBER’S BEANIE BROWNIE PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter327#CC_327",
      "id": "RR_327",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ETHEL MONTGOMERY ST. JOHN’S NESSELRODE PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter328#CC_328",
      "id": "RR_328",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THELMA LOU’S CHOCOLATE MERINGUE BIRTHDAY PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter329#CC_329",
      "id": "RR_329",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DARLING BABY CHESS PIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter330#CC_330",
      "id": "RR_330",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SHARON’S EASY CHERRY COBBLER DESSERT")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter331#CC_331",
      "id": "RR_331",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DOUG DARLING’S MAKES-ITS-OWN-CRUST COCONUT PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter333#CC_333",
      "id": "RR_333",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BEST FOR LAST STRAWBERRY PIE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter335#CC_335",
      "id": "RR_335",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PUDDINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter336#CC_336",
      "id": "RR_336",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GOOBER’S BANANA PUDDING")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter337#CC_337",
      "id": "RR_337",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FLOYD AND AL’S BANANA PUDDING")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter338#CC_338",
      "id": "RR_338",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MARY GRACE’S BREAD PUDDING")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter339#CC_339",
      "id": "RR_339",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OLIVER GOSSAGE’S DATE NUT PUDDING")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter340#CC_340",
      "id": "RR_340",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PERSIMMON PUDDING PYLE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter341#CC_341",
      "id": "RR_341",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLANE TO MEXICO FLAN DE QUESO (SPANISH CUSTARD DESSERT)")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter342#CC_342",
      "id": "RR_342",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OPIE’S BANANA SPLIT DESSERT")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter343#CC_343",
      "id": "RR_343",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SARAH’S STEAMED CRANBERRY PUDDING")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter344#CC_344",
      "id": "RR_344",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VERY LAST MINUTE CHOCOLATE MOUSSE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter345#CC_345",
      "id": "RR_345",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAYBERRY HOTEL PISTACHIO PUDDING")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter346#CC_346",
      "id": "RR_346",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JOHN DANBY’S RICE CUSTARD PUDDING")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter347#CC_347",
      "id": "RR_347",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OTIS’S BANANAS FOSTER RUM PUDDING")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter348#CC_348",
      "id": "RR_348",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DR. HARRISON EVERETT BREEN OF NEW YORK CITY RICE PUDDING")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter349#CC_349",
      "id": "RR_349",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MEN ARE ORBITING THE EARTH BROWNIE PUDDING")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter350#CC_350",
      "id": "RR_350",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MRS. PENDLETON’S PERSIMMON PUDDING")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter351#CC_351",
      "id": "RR_351",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ESQUIRE CLUB LEMON-PINEAPPLE CHIFFON PUDDING")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter352#CC_352",
      "id": "RR_352",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TOM STRONGBOW’S BAKED INDIAN PUDDING")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter353#CC_353",
      "id": "RR_353",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUMMIT MEETING ADVOKAAT (BRANDY CUSTARD)")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter354#CC_354",
      "id": "RR_354",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEAN DARLING’S FAVORITE BREAD PUDDING")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter355#CC_355",
      "id": "RR_355",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BANKER’S BAKED CUSTARD")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter356#CC_356",
      "id": "RR_356",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANDY’S PETUNIA POT DE CRÈME")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter359#CC_359",
      "id": "RR_359",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("REFRIGERATOR TREATS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter360#CC_360",
      "id": "RR_360",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUNT BEE’S HOMEMADE STRAWBERRY ICE CREAM")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter361#CC_361",
      "id": "RR_361",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ED’S REFRIGERATION FRUIT ICE CREAM")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter362#CC_362",
      "id": "RR_362",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MR. SCHWAMP’S CHOCOLATE ICE CREAM")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter363#CC_363",
      "id": "RR_363",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEPUTY FICE ICE CREAM SANDWICH DESSERT")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter364#CC_364",
      "id": "RR_364",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IT’S A FUN DAY FRESH PEACH ICE CREAM")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter365#CC_365",
      "id": "RR_365",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DR. BAILEY’S HOMEMADE ORANGE SHERBET")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter366#CC_366",
      "id": "RR_366",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INSPECTOR UPCHURCH’S ICE CREAM CHURN")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter367#CC_367",
      "id": "RR_367",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PEGGY’S CHOCOLATE NUT CRUNCH")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter368#CC_368",
      "id": "RR_368",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BANNERTOWN BANANA BRITTLE DESSERT")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter369#CC_369",
      "id": "RR_369",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COCONUT MACAROON DESSERT")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter370#CC_370",
      "id": "RR_370",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OLD LADY CRUMP’S BUTTERSCOTCH ICE CREAM CRUNCH SQUARES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter371#CC_371",
      "id": "RR_371",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAYOR’S CHOCOLATE RIBBON DELIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter372#CC_372",
      "id": "RR_372",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BARNEY’S DEADLY GAME DESSERT")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter373#CC_373",
      "id": "RR_373",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OPIE’S FIRST DATE DESSERT")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter374#CC_374",
      "id": "RR_374",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAVIS NEFF’S AMBROSIA")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter375#CC_375",
      "id": "RR_375",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BOOKIE BARBER’S CHOCOLATE ICEBOX DESSERT")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter376#CC_376",
      "id": "RR_376",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TRIVIAL TRIVIALITIES AMARETTO TRIFLE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter377#CC_377",
      "id": "RR_377",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FLOYD’S ENGLISH TRIFLE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter378#CC_378",
      "id": "RR_378",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MARY SCOBEY’S MILK AND COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter379#CC_379",
      "id": "RR_379",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MR. SCHWAMP’S FROZEN FRUIT SALAD")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter380#CC_380",
      "id": "RR_380",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PHILOSOPHICAL MEANDERINGS DESSERT")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter381#CC_381",
      "id": "RR_381",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NEWTON’S ORANGE PINEAPPLE SKINNER PARFAIT")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter382#CC_382",
      "id": "RR_382",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OPIE’S BLOCKS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter383#CC_383",
      "id": "RR_383",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FLOYD’S SHAVING CREAM AND CHERRY YUM-YUM")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter384#CC_384",
      "id": "RR_384",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BABY-MAKES-THREE FRUIT SHERBET")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter385#CC_385",
      "id": "RR_385",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WEB-FOOTED, RED-CRESTED LAKE LOON DESSERT")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter386#CC_386",
      "id": "RR_386",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STRAWBERRY FIXER-UPPER")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter387#CC_387",
      "id": "RR_387",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COUNTRY BOYS’ FRESH FRUIT COMPOTE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter388#CC_388",
      "id": "RR_388",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FALCON KEEPER’S FRESH FRUIT TRIFLE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter389#CC_389",
      "id": "RR_389",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SCOOP FIFE’S CUP OF JAVA SUNDAE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter390#CC_390",
      "id": "RR_390",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPISODE MENU")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/index#CC_in1",
      "id": "RR_in1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-007288a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0